<template lang="pug">
  .module__main
    .module__title.aml-history__title
      el-tooltip(content="Вернуться к кошелькам" placement="top")
        el-button(
          icon="el-icon-back"
          circle
          size="mini"
          @click="goBack"
        )
      span История AML-проверок
    .module-content__container
      .aml-history__address
        span Адрес
        strong {{ address }}
      .table__container
        .table-list__container
          el-table(
            v-loading="isLoading"
            :data="amlReports.list"
            row-key="checkId"
            empty-text="История AML-проверок пока пуста"
            style="width: 100%; font-size: 12px"
          )
            el-table-column(type="expand" width="48")
              template(slot-scope="scope")
                aml-report-details(
                  :report="scope.row"
                  :show-technical="true"
                )
            el-table-column(prop="checkedAt" label="Время проверки" width="180")
              template(slot-scope="scope") {{ formatDate(scope.row.checkedAt) }}
            el-table-column(prop="riskScore" label="AML" width="110")
              template(slot-scope="scope")
                span.aml-history__score(:style="riskStyle(scope.row.analysisRisk)") {{ formatPercent(scope.row.riskScore) }}
            el-table-column(prop="analysisRisk" label="Результат" width="150")
              template(slot-scope="scope")
                el-tag(:type="riskTagType(scope.row.analysisRisk)" size="mini") {{ riskLabel(scope.row.analysisRisk) }}
            el-table-column(prop="provider" label="Сервис" width="100")
              template(slot-scope="scope") {{ providerName(scope.row.provider) }}
            el-table-column(prop="txid" label="TxID" min-width="280" show-overflow-tooltip)
          el-pagination(
            v-if="amlReports.pagination.total > perPage"
            :total="amlReports.pagination.total"
            :page-size="perPage"
            :current-page="page"
            background
            layout="prev, pager, next"
            @current-change="loadReports"
          )
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import AmlReportDetails from '@/components/AmlReportDetails.vue';
import { LOAD_AML_REPORTS } from '@/store/const/wallets';
import {
  amlRiskLabel,
  amlRiskStyle,
  amlRiskTagType,
  formatAmlDate,
  formatAmlPercent,
} from '@/utils/aml';

export default {
  name: 'AmlReports',
  components: { AmlReportDetails },
  data() {
    return {
      page: 1,
      perPage: 20,
    };
  },
  computed: {
    ...mapGetters(['loading']),
    ...mapGetters('wallets', ['amlReports']),
    address() {
      return String(this.$route.params.address || '');
    },
    isLoading() {
      return this.loading(LOAD_AML_REPORTS) === 'loading';
    },
  },
  async mounted() {
    await this.loadReports();
  },
  methods: {
    ...mapActions('wallets', {
      loadAmlReports: LOAD_AML_REPORTS,
    }),
    formatDate: formatAmlDate,
    formatPercent: formatAmlPercent,
    riskLabel: amlRiskLabel,
    riskStyle: amlRiskStyle,
    riskTagType: amlRiskTagType,
    providerName(provider) {
      return String(provider || '').toLowerCase() === 'bitok'
        ? 'BitOK'
        : provider;
    },
    async loadReports(page = 1) {
      this.page = page;
      await this.loadAmlReports({
        address: this.address,
        params: { page, per_page: this.perPage },
      });
    },
    goBack() {
      this.$router.push({ name: 'Wallets' });
    },
  },
};
</script>

<style scoped>
.aml-history__title {
  display: flex;
  align-items: center;
  gap: 10px;
}

.aml-history__address {
  display: flex;
  gap: 10px;
  margin-bottom: 16px;
  text-align: left;
}

.aml-history__address strong {
  overflow-wrap: anywhere;
}

.aml-history__score {
  display: inline-block;
  min-width: 64px;
  padding: 4px 8px;
  border: 1px solid;
  border-radius: 4px;
  text-align: center;
}
</style>
